// Material
import { List } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { ProfileActionItem } from '$common/profile-action-item'

import { AddUserIcon } from '$common/icons'
import { LinkIcon } from '$common/icons/link'
import { AdministratorIcon } from '$common/icons/administrator'
import { SharedMediaProfileActionItem } from '$common/shared-media-profile-action-item'
// logic
import { useHall } from '$logic/hall/react-hook'
import { useRoom } from '$logic/room/react-hook'
import { useHallAdminsCount } from '$logic/subscription/react-hook'
import {
  openAddHallMembers,
  openHallAdmins,
  openHallInviteLinks,
  openHallSubscribers,
} from '$logic/router'
import { MemberPermissions } from '$logic/types/subscription'
import { toLocale } from '$func/text'
// Localization
import { t } from '$i18n'
import { GroupIcon } from '$common/icons'

interface Props {
  hallId: string
  isGroup: boolean
  permissions: MemberPermissions
}

const StyledList = styled(List)`
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
`

function HallAdminsActionItem({ hallId }: { hallId: string }) {
  const { count, loading } = useHallAdminsCount(hallId)

  return (
    <ProfileActionItem
      Icon={<AdministratorIcon />}
      onClick={() => openHallAdmins(hallId)}
      secondaryText={toLocale(count)}
      secondaryTextLoading={loading}
    >
      {t('profile.hall.actions.admins')}
    </ProfileActionItem>
  )
}

export function HallProfileActions({ hallId, isGroup, permissions }: Props) {
  const { entity: hall, loading: hallLoading } = useHall(hallId)
  const room = useRoom(hallId)

  return (
    <StyledList>
      {permissions?.inviteViaLink && room?.type === 'CHANNEL' && (
        <ProfileActionItem
          Icon={<LinkIcon />}
          onClick={() => openHallInviteLinks(hallId)}
        >
          {t('profile.hall.actions.inviteViaLink')}
        </ProfileActionItem>
      )}

      {permissions?.addMembers && (
        <ProfileActionItem
          Icon={<AddUserIcon />}
          onClick={() => openAddHallMembers(hallId, false)}
        >
          {room?.type === 'GROUP'
            ? t('profile.hall.actions.addMember')
            : t('profile.hall.actions.addSubscriber')}
        </ProfileActionItem>
      )}

      {(permissions?.isAdmin || isGroup) && (
        <ProfileActionItem
          Icon={<GroupIcon />}
          onClick={() => openHallSubscribers(hallId)}
          secondaryText={toLocale(hall.membersCount)}
          secondaryTextLoading={hallLoading}
        >
          {room?.type === 'GROUP'
            ? t('profile.hall.actions.members')
            : t('profile.hall.actions.subscribers')}
        </ProfileActionItem>
      )}

      {permissions?.isAdmin && room?.type === 'CHANNEL' && (
        <HallAdminsActionItem hallId={hallId} />
      )}

      <SharedMediaProfileActionItem roomId={hallId} />
    </StyledList>
  )
}
